import AWS from 'AWS'

export const getS3 = (
  identityId: CognitoResultDTO['identityId'],
  token: CognitoResultDTO['token']
) => {
  AWS.config.credentials = new AWS.CognitoIdentityCredentials(
    {
      IdentityPoolId: 'cn-north-1:366c7385-20fc-4729-9e09-eb84f8992d6d',
      IdentityId: identityId,
      Logins: {
        'cognito-identity.cn-north-1.amazonaws.com.cn': token,
      },
    },
    {
      region: 'cn-north-1',
    }
  )

  AWS.config.update({ region: 'cn-northwest-1' })
  return new AWS.S3({ apiVersion: '2006-03-01' })
}

// 建立连接
export function createMultipartUpload(bucket: string, key: string, s3: any, type: string) {
  return new Promise((resolve, reject) => {
    s3.createMultipartUpload(
      {
        Key: key,
        Bucket: bucket,
        ContentType: type,
      },
      (err: any, data: any) => {
        if (err) return reject(err)
        resolve(data)
      }
    )
  })
}

// 上传一个分片
export async function uploadChunk(
  f: Blob,
  uploadId: any,
  key: string,
  bucket: string,
  num: any,
  s3: any
) {
  return new Promise((resolve, reject) => {
    s3.uploadPart(
      {
        Bucket: bucket,
        Key: key,
        PartNumber: num,
        UploadId: uploadId,
        Body: f,
      },
      (err: any, data: any) => {
        if (err) return reject(err)
        resolve(data)
      }
    )
  })
}

// 取消连接
export async function abortMultipartUpload(bucket: string, key: string, uploadId: any, s3: any) {
  return new Promise((resolve, reject) => {
    s3.abortMultipartUpload(
      {
        Bucket: bucket,
        Key: key,
        UploadId: uploadId,
      },
      (err: any, data: any) => {
        if (err) return reject(err)
        resolve(data)
      }
    )
  })
}

// 将分片合并
export async function completeMultipartUpload(
  bucket: string,
  key: string,
  parts: any,
  uploadId: any,
  s3: any
) {
  return new Promise((resolve, reject) => {
    s3.completeMultipartUpload(
      {
        Bucket: bucket,
        Key: key,
        MultipartUpload: {
          Parts: parts,
        },
        UploadId: uploadId,
      },
      (err: any, data: any) => {
        if (err) return reject(err)
        resolve(data)
      }
    )
  })
}
